import { AttributeTypes, AttributeValueTypes } from "../enums";
import {
  IAPIProductAttributesOptionsResponseModel,
  IAPIProductAttributesResponseModel,
  IAPIProductGridResponse,
} from "../interfaces";

export class CreateProductResponse {
  id: string;
  constructor(data?: Partial<CreateProductResponse>) {
    this.id = data?.id || "";
  }
}

export class GetProductAttributesResponseModel {
  id: string;
  name: string;
  attributeType: AttributeTypes;
  valueType: AttributeValueTypes;
  options: GetProductAttributesOptionsResponseModel[];
  constructor(data?: Partial<GetProductAttributesResponseModel>) {
    this.id = data?.id || "";
    this.name = data?.name || "";
    this.options = data?.options || [];
    this.attributeType = data?.attributeType || AttributeTypes.Custom;
    this.valueType = data?.valueType || AttributeValueTypes.Text;
  }

  static deserialize(
    apiResponse: IAPIProductAttributesResponseModel
  ): GetProductAttributesResponseModel {
    if (!apiResponse) return new GetProductAttributesResponseModel();

    const data: Partial<GetProductAttributesResponseModel> = {
      id: apiResponse.id,
      name: apiResponse.name,
      options: GetProductAttributesOptionsResponseModel.deserializeList(
        apiResponse.options
      ),
    };

    return new GetProductAttributesResponseModel(data);
  }

  static deserializeList(
    list: IAPIProductAttributesResponseModel[]
  ): GetProductAttributesResponseModel[] {
    const newList: GetProductAttributesResponseModel[] = [];

    if (Array.isArray(list)) {
      list.forEach((data: IAPIProductAttributesResponseModel) => {
        newList.push(GetProductAttributesResponseModel.deserialize(data));
      });
    }

    return newList;
  }
}

export class GetProductAttributesOptionsResponseModel {
  id: string;
  name: string;
  constructor(data?: Partial<GetProductAttributesOptionsResponseModel>) {
    this.id = data?.id || "";
    this.name = data?.name || "";
  }

  static deserialize(
    apiResponse: IAPIProductAttributesOptionsResponseModel
  ): GetProductAttributesOptionsResponseModel {
    if (!apiResponse) return new GetProductAttributesOptionsResponseModel();

    const data: Partial<GetProductAttributesOptionsResponseModel> = {
      id: apiResponse.id,
      name: apiResponse.name,
    };

    return new GetProductAttributesOptionsResponseModel(data);
  }

  static deserializeList(
    list: IAPIProductAttributesOptionsResponseModel[]
  ): GetProductAttributesOptionsResponseModel[] {
    const newList: GetProductAttributesOptionsResponseModel[] = [];

    if (Array.isArray(list)) {
      list.forEach((data: IAPIProductAttributesOptionsResponseModel) => {
        newList.push(
          GetProductAttributesOptionsResponseModel.deserialize(data)
        );
      });
    }

    return newList;
  }
}

export class GetProductGridResponseModel {
  id: string;
  name: string;
  description: string;
  createdDate: Date;
  constructor(data?: Partial<GetProductGridResponseModel>) {
    this.id = data?.id || "";
    this.name = data?.name || "";
    this.description = data?.description || "";
    this.createdDate = data?.createdDate || new Date();
  }

  static deserializeList(
    list: IAPIProductGridResponse[]
  ): GetProductGridResponseModel[] {
    const newList: GetProductGridResponseModel[] = [];
    if (Array.isArray(list)) {
      list.forEach((data: IAPIProductGridResponse) => {
        newList.push(new GetProductGridResponseModel(data));
      });
    }
    return newList;
  }
}
